"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Icon_1 = __importDefault(require("../../../common/js/atoms/Icon"));
const Tooltip_1 = __importDefault(require("../../atoms/Tooltip"));
const TooltipPosition_1 = __importDefault(require("../../enums/TooltipPosition"));
const AssetsSoftwareColumnHeaderWithTooltip = (props) => {
    const { title, tooltip, iconName } = props;
    return (react_1.default.createElement("div", { className: "znd-table-head" },
        react_1.default.createElement("span", { className: "znd-table-head__title" }, title),
        react_1.default.createElement(Tooltip_1.default, { className: "align-self-center", label: tooltip, position: TooltipPosition_1.default.bottomCenter },
            react_1.default.createElement(Icon_1.default, { name: iconName, className: 'znd-table-head__icon' }))));
};
exports.default = AssetsSoftwareColumnHeaderWithTooltip;
